import { FunctionalComponent, h } from 'preact';
import Usercentrics from '@usercentrics/cmp-browser-sdk';
import styled from 'styled-components';

interface Props {
  UC: Usercentrics;
}

const GlobalContainer = styled.div`
  /* Reset defaults that are inherited through the shadow dom (mostly font related) */
  all: initial; // TODO (EUD-60) "all: initial" not supported by IE11 and old Edge versions
  /* Set font defaults */
  color: ${({ theme }) => theme.typography.color.primary};
  direction: ${({ theme }) => (theme.typography.rtlEnabled ? 'rtl' : 'unset')};
  font-family: ${({ theme }) => theme.typography.font};
  font-size: ${({ theme }) => theme.typography.size.medium};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  /* Normalize.css: Correct the line height in all browsers */
  line-height: 1.15;
  /* Normalize.css: Prevent adjustments of font size after orientation changes in iOS */
  -webkit-text-size-adjust: 100%;
  -webkit-overflow-scrolling: touch;

  *,
  *:after,
  *:before {
    /* Use border-box for everything so working with margin/padding/width is easier */
    box-sizing: border-box;
  }

  /* Normalize.css: Add the correct display in IE 10 */
  [hidden] {
    display: none;
  }

  a {
    font-weight: normal;
  }

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    cursor: pointer;
    font-family: inherit;
    line-height: inherit;
    transition: background-color 0.2s ease-in-out;
  }

  /* Normalize.css: Remove the border on images inside links in IE 10 */
  img {
    border-style: none;
  }
`;

const GlobalStyles: FunctionalComponent<Props> = ({ UC, children }) => {
  const settings = UC.getSettings();

  return (
    <GlobalContainer aria-label={settings.ui.ariaLabels.usercentricsCMPUI} data-testid="uc-container">
      {children}
    </GlobalContainer>
  );
};

export default GlobalStyles;
